<template>
    <div v-if="shop" class="popup full">
        <div class="popup-container">
            <!-- TopContainer -->
            <div class="top-container p-0">
                <!-- CloseButton -->
                <n-close-button path="home" />
                <!-- ShopName -->
                <div>
                    <h4 class="mb-1">{{ shop.merchantName }} {{ shop.name }}</h4>
                    <div class="subtitle font-weight-500 mb-3" :class="computedStatusClass">
                        <span v-if="shop.closed" class="text-red">暫時關閉接單</span>
                        <span v-else-if="shop.isBusy" class="text-red">（現時店家繁忙）</span>
                        <span v-else>{{ computedStatus }}</span>
                    </div>
                </div>
            </div>
            <!-- ShopOpeningHours -->
            <div class="bg-image-default border-radius-8 p-3 mb-3">
                <div class="flex-element between">
                    <div class="px-2 text-dark-warm-grey font-17 font-weight-500 mb-2">每日營業時間</div>
                </div>
                <div class="time-list-container mb-3">
                    <div v-for="(weekday, index) in computedOpeningHours" :key="index">
                        <span :class="{ active: weekday.active }" class="name">{{ weekday.label }}</span>
                        <div class="time">
                            <div v-for="range in weekday.value" :key="range">{{ range }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ShopPhone -->
            <div class="flex-element between center pb-2 b-b-1">
                <div>
                    <div class="font-17 text-dark-warm-grey mb-1">電話</div>
                    <div class="font-19 text-black font-weight-700">{{ shop.phone }}</div>
                </div>
                <button class="p-0 border-radius-50 bg-white-f5 size-40 line-height-1">
                    <a :href="'tel:' + shop.phone" target="_blank">
                        <img src="@/assets/icons/ic-phone.svg" />
                    </a>
                </button>
            </div>
            <!-- ShopAddress -->
            <div class="flex-element pt-3">
                <div>
                    <div class="font-17 text-dark-warm-grey mb-1">地址</div>
                    <div class="font-19 text-black font-weight-700 mb-3">{{ shop.address }}</div>
                </div>
            </div>
            <!-- ShopMap -->
            <div class="mb-3">
                <iframe width="100%" height="343" frameborder="0" style="border: 0" :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCUkucStOUB-kNdLnug0MY2tdAgjtmNB4U&q=' + shop.address" allowfullscreen="allowfullscreen"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

export default {
    computed: {
        ...mapState({
            shop: (state) => state.shop,
        }),

        //計算店家現時狀態
        computedStatus() {
            let today = moment().isoWeekday() - 1
            let todayOpeningHours = this.shop.openingHours ? this.shop.openingHours[today] : null
            if (!todayOpeningHours && todayOpeningHours.length < 1) return '休息日'
            let status = '休息中'
            _.forEach(todayOpeningHours, (time) => {
                if (moment().isBetween(moment(time.start, 'HH:mm'), moment(time.end, 'HH:mm'))) {
                    status = '營業中'
                }
            })
            return status
        },

        //計算店家現時狀態的Style
        computedStatusClass() {
            switch (this.computedStatus) {
                case '營業中':
                    return 'text-green'
                case '休息中':
                    return 'text-red'
                default:
                    return ''
            }
        },

        // 計算店家營業時間
        computedOpeningHours() {
            if (!this.shop.openingHours) return []
            const today = moment().isoWeekday() - 1
            const weekdays = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
            let openingHours = []
            _.forEach(weekdays, (weekday, index) => {
                const todayOpeningHours = this.shop.openingHours[index]
                let value = []
                console.log(todayOpeningHours)
                if (todayOpeningHours.length < 0 || !todayOpeningHours) {
                    openingHours.push({ label: weekday, value: ['休息日'], active: today === index })
                } else if (todayOpeningHours[0].start == '') {
                    openingHours.push({ label: weekday, value: ['休息日'], active: today === index })
                } else {
                    _.forEach(todayOpeningHours, (time) => {
                        value.push(time.start + ' ~ ' + time.end)
                    })
                    openingHours.push({ label: weekday, value: value, active: today === index })
                }
            })
            return openingHours
        },
    },
}
</script>
